<aside>
  <nav id="side-bar" [class.open]="isVisible()" [class.closed]="!isVisible()">
    <div class="scrollable-content">
      <div class="app-logo">
        <img [src]="logoUrl() || 'assets/logo.png'" alt="Logo"/>
      </div>
      <a class="navigation-button" routerLink="/" id="button-home" [appBlurWhen]="hasNavigated">Home</a>
      @for (item of navigationItems(); track item) {
        <a class="navigation-button" [routerLink]="item.routerLinkCommands" routerLinkActive="active" [appBlurWhen]="hasNavigated" [id]="'button-' + item.id" ariaCurrentWhenActive="page">{{item.description}}</a>
      }
      <div class="navigation-divider" id="divider-close-menu"></div>
      <button class="navigation-button" id="button-close-menu" (click)="close()">
        <svg-icon alt="" src="assets/icons/common/close.svg"></svg-icon>
        <span>Close Menu</span>
      </button>
    </div>
  </nav>
</aside>
